import Footer from "../components/Footer";
import Header from "../components/Header";

export default function Landing() {
  return (
    <div className="min-h-screen flex flex-col mb-40">
      <Header />
      <main className="flex-grow justify-center place-content-center h-full">
        <div className=" mx-10 sm:mx-20">
          <div className=" grid grid-cols-1 sm:grid-cols-2 justify-center place-items-center">
            <div className="text-justify">
              <div className=" text-xl font-semibold mb-5">
                About Mizoram Economic Review
              </div>
              The Mizoram Economic Review is a bi-annual journal published by
              the Mizoram Economic Association. It features original academic
              research on economic, social, and sustainable development issues
              in the northeastern region of India, with a particular focus on
              the state of Mizoram. The journal also welcomes abstracts from
              Ph.D. and M.Phil. research scholars who have recently been awarded
              their degrees from recognized universities. Additionally, book
              reviews and commentaries on economic issues are accepted for
              publication. The journal aims to provide an academic platform for
              researchers, both within and outside the northeastern region, to
              share their views, analyses, and meaningful suggestions on topics
              specifically relevant to the region. The journal is committed to
              maintaining high standards of publication ethics and employs a
              rigorous double-blind peer review process to ensure the quality
              and integrity of its content.
            </div>
            <div className="justify-center flex flex-col place-items-center mt-10 sm:mt-0 sm:mb-0 mb-10">
              <img src="mea.webp" className="h-96 w-auto" alt="Mizoram Economic Review Cover"/>
              <div className="text-sm font-semibold pt-2">ISSN 2581-7523</div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
